import { ApolloProvider } from '@apollo/client/react'
import { DefaultSeo } from 'next-seo'
import '../styles/base.css'
import SEOSelect from 'next-seo-select.config'
import SEOModellink from 'next-seo-modellink.config'

import isModellinkSite from '../helpers/isModellinkSite'
import { createApolloClient } from '../lib/createApolloClient'

function App({ Component, pageProps }) {
  const apolloClient = createApolloClient()
  const SEO = isModellinkSite() ? SEOModellink : SEOSelect

  return (
    <ApolloProvider client={apolloClient}>
      <DefaultSeo {...SEO} />
      <Component {...pageProps} />
    </ApolloProvider>
  )
}

export default App
